<div class="content-box"></div>

<movie-site_top-menu [navActions]="navActions()" [movie]="movie()" [appendSidemenuTo]="element" />

@if (movie()) {
  <div class="branded-movie-conversion--sharing">
    <ush-movie-tell-friends [movie]="movie()!" />
  </div>

  <div class="branded-movie-conversion">
    <div class="branded-movie-conversion--head">
      <div class="branded-movie-conversion--background">
        <img [ngSrc]="movie()!.tilePhotoUrl!" fill priority [alt]="movie()!.title! + ' tile image'" priority="true" />
      </div>
    </div>
    <div class="branded-movie-conversion--body">
      <div class="branded-movie-conversion--logo" *ngIf="movie()!.logoUrl">
        <a
          class="branded-movie-conversion--logo--wrapper"
          *ngIf="!hideLogoTitle"
          [routerLink]="[routePath, 'film-info']"
          [fragment]="'landing'"
          (click)="onClickFilmInfo()"
        >
          @if (movie()?.logoUrl) {
            <div class="branded-movie-conversion--logo--wrapper-support">
              <img
                class="branded-movie-conversion--movie--logo"
                [ngSrc]="movie()!.logoUrl!"
                sizes="(max-width:530px) 90vw, (max-width:1000px) 50vw, 30vw"
                height="150"
                width="450"
                priority="true"
                [alt]="'video thumbnail image of ' + movie()?.title"
              />
            </div>
          } @else {
            <h2 *ngIf="!hideTitleText" class="branded-movie-conversion--movie--title">{{ movie()?.title }}</h2>
          }
        </a>
      </div>

      <!-- Show in mobile devices -->
      <ng-template #filmInteractionComponentMobile />

      <div class="branded-movie-conversion--wrapper">
        <div class="branded-movie-conversion--portrait-wrapper">
          <div class="branded-movie-conversion--portrait">
            <a [routerLink]="[routePath, 'film-info']" [fragment]="'landing'">
              <img
                [ngSrc]="movie()!.portraitPhotoUrl!"
                width="360"
                height="540"
                priority="true"
                [alt]="movie()!.title! + ' portrait'"
              />
            </a>
            <ng-template #filmInteractionComponentDesktop />
            <movie-site-nav-action [navAction]="navActionFilmInfo" />
          </div>
        </div>

        <div class="branded-movie-conversion--showtimes--wrapper">
          <div class="branded-movie-conversion--showtimes--header">
            @if (hasShowtimes) {
              <a
                class="branded-movie-conversion--showtimes--header--tab-selector"
                [class.active]="tab() === 'showtimes'"
                [class.notBrandcolorRedeable]="!isBrandColorReadable()"
                (click)="changeTab('showtimes')"
              >
                <fa-icon [icon]="faTicket" class="branded-movie-conversion--ticket-icon" />
                <h2
                  class="branded-movie-conversion--title"
                  i18n="@@movie-conversion.title.inCinemas"
                  data-translate="movie-conversion.title.inCinemas"
                >
                  In Cinemas
                </h2>
              </a>
            }

            @if (hasStreaming) {
              <a
                class="branded-movie-conversion--showtimes--header--tab-selector"
                [class.active]="tab() === 'streaming'"
                [class.notBrandcolorRedeable]="!isBrandColorReadable()"
                (click)="changeTab('streaming')"
              >
                <fa-icon [icon]="faTv" class="branded-movie-conversion--streaming-icon" />
                <h2
                  class="branded-movie-conversion--title"
                  i18n="@@movie-conversion.title.watchAtHome"
                  data-translate="movie-conversion.title.watchAtHome"
                >
                  Watch at home
                </h2>
              </a>
            }

            @if (movie()?.trailerLink) {
              <movie-site-nav-action [navAction]="navActionTrailer()" />
            }

            @if (hasCompetition()) {
              <movie-site-nav-action [navAction]="navActionCompetition()" />
            }

            @for (navAction of customNavigationButtonActions(); track $index) {
              <movie-site-nav-action [navAction]="navAction" />
            }

            <!-- @if (movie && hasAssets) {
              <div class="branded-movie-conversion--assets">
                <ush-assets-locker-link
                  [movie]="movie"
                  [hideLabel]="true"
                  [label]="ASSETSLOCKER_LABEL"
                  [labelButton]="ASSETSLOCKER_LABEL_BUTTON"
                />
              </div>
            } -->
          </div>
          @if (movie()) {
            @switch (tab()) {
              @case ('showtimes') {
                @if (hasShowtimes) {
                  <div
                    class="branded-movie-conversion--showtimes"
                    [class.notBrandcolorRedeable]="!isBrandColorReadable()"
                  >
                    <ush-showtime-streaming-in-cinemas
                      [movie]="movie()!"
                      [inCinemasAddon]="inCinemaAddon"
                      (showsLoaded)="onShowtimesLoaded()"
                    />
                  </div>
                }
              }
              @case ('streaming') {
                @if (hasStreaming) {
                  <div class="branded-movie-conversion--streaming">
                    <ush-showtime-streaming-watch-at-home
                      [movie]="movie()!"
                      countrySelectorPanelStyleClass="streaming-country-selector-panel movie-conversion-streaming-country-selector-panel"
                      (streamingPlatformsLoaded)="onStreamingPlatformsLoaded()"
                    />
                  </div>
                }
              }
            }
          }

          <!-- Subscription with same logic as movie detail -->
          <ush-showtime-streaming
            [movie]="movie()"
            [onlySubscription]="true"
            [onlySubscriptionType]="subscriptionType"
          />

          @if (showCompetitionInConversion()) {
            <section id="competition" class="branded-movie-conversion--competition">
              <ush-movie-competition
                [movieFriendlyUrl]="movie()?.friendlyUrl ?? ''"
                [typeFormUrl]="movie()?.properties?.competition?.typeFormUrl ?? ''"
                [typeFormData]="movie()?.properties?.competition?.typeFormData ?? ''"
              />
            </section>
          }
        </div>
      </div>
    </div>

    <section class="footer-component">
      <footer-component />
    </section>
  </div>
}
